import { render, staticRenderFns } from "./Swatch.vue?vue&type=template&id=43048692&scoped=true&"
import script from "./Swatch.vue?vue&type=script&lang=ts&"
export * from "./Swatch.vue?vue&type=script&lang=ts&"
import style0 from "./Swatch.vue?vue&type=style&index=0&id=43048692&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43048692",
  null
  
)

export default component.exports